import {useSuspenseChildRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsOverviewRoute} from '../../../routes/overview-route'

export const useAssigneesQuery = () => useSuspenseChildRouteQuery(pullRequestsOverviewRoute, 'assignees')
export const useReviewRequestsQuery = () => useSuspenseChildRouteQuery(pullRequestsOverviewRoute, 'review_requests')
export const useDevelopmentQuery = () => useSuspenseChildRouteQuery(pullRequestsOverviewRoute, 'development')
export const useLabelsQuery = () => useSuspenseChildRouteQuery(pullRequestsOverviewRoute, 'labels')
export const useParticipantsQuery = () => useSuspenseChildRouteQuery(pullRequestsOverviewRoute, 'participants')
